// extracted by mini-css-extract-plugin
export default {"toggleSwitch":"Toggle_toggleSwitch__fgq5l","slider":"Toggle_slider__CUiDw","disabled":"Toggle_disabled__T44Z5"};